@if (incidence) {

<!-- Información General de la consulta -->
<div class="incidence-info" animate.enter="loaded-fade-enter">
  <div class="incidence-info-header">
    <h4>Información de la consulta</h4>
    <div class="incidence-header-project-data">
      @if (incidence.ProjectImageIconFile?.FileUri) {
      <div class="project-icon">
        <img [src]="incidence.ProjectImageIconFile.FileUri" alt="Icono" class="project-icon-img">
      </div>
      }
      <span class="info-value">
        <span class="client-name">{{ incidence.ClientName }}</span>
        <span class="project-name">{{ incidence.ProjectName }}</span>
      </span>
    </div>
    <div class="incidence-header-data">
      <div class="incidence-code">
        <span class="code-label"></span> <strong class="code-value">{{incidence.IncidenceCode}}</strong>
      </div>
      @if (changeStatusControl && isAdmin) {
      <ng-container *ngTemplateOutlet="changeStatusControl"></ng-container>
      } @else {
      <div class="incidence-status" [class]="'status-' + incidence.IdStatus">
        {{ incidence.Status | titlecase }}
      </div>
      }
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6 col-md info-subject-container">
      <div class="info-item info-item-subject">
        <label class="info-label">Asunto</label>
        <span class="info-value">{{ incidence.Subject }}</span>
      </div>
    </div>
    @if (isAdmin) {
    <div class="col-sm-6 col-md-auto info-no-auto-close-container">
      <div class="info-item info-item-no-auto-close">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="noAutoCloseCheck" [checked]="incidence.NoAutoClose" [disabled]="savingNoAutoClose" (change)="onNoAutoCloseChange($event)">
          <label class="form-check-label" for="noAutoCloseCheck">No cerrar automáticamente</label>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-md-auto info-phone-call-container">
      <div class="info-item info-item-phone-call">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="phoneCallNeededCheck" [checked]="incidence.PhoneCallNeeded" [disabled]="savingPhoneCallNeeded" (change)="onPhoneCallNeededChange($event)">
          <label class="form-check-label" for="phoneCallNeededCheck">Ha necesitado llamada</label>
        </div>
      </div>
    </div>
    }
    <div class="col-6 col-md-auto info-creation-date-container">
      <div class="info-item info-date info-item-creation-date">
        <label class="info-label">Fecha de creación</label>
        <span class="info-value">{{ incidence.CreationDate }}</span>
      </div>
    </div>
    <div class="col-6 col-md-auto info-last-update-date-container">
      <div class="info-item info-date info-item-last-update-date">
        <label class="info-label">Última actualización</label>
        <span class="info-value">{{ incidence.LastUpdateDate }}</span>
      </div>
    </div>
  </div>
</div>


<!-- Información del usuario -->
<div class="incidence-info-user">
  <div class="incidence-info-header">
    <h4>Información del usuario</h4>
    <button class="btn btn-link btn-sm" (click)="toggleOtherIncidences()">Otras consultas del usuario</button>
  </div>

  <div class="row">
    <div class="col-md-6 col-lg-3">
      <div class="info-item">
        <label class="info-label">Email de contacto</label>
        <span class="info-value">{{ incidence.ContactEmail }}</span>
      </div>
    </div>
    @if (contactDataArray.length > 0) {
    @for (item of contactDataArray; track item.key) {
    <div class="col-md-6 col-lg-3">
      <div class="info-item">
        <label class="info-label">{{ item.key }}:</label>
        <span class="info-value">{{ item.value }}</span>
      </div>
    </div>
    }
    }
  </div>
</div>
}
